import dynamic from 'next/dynamic';
import SimpleGrid from '@prezzee/ribbon-ui/lib/components/SimpleGrid';
import { useMemo } from 'react';
import { getCmsItemCodename, transformHeroBannerBlockData, transformStoreHeroBannerData } from './util';

import { SystemProps } from '@chakra-ui/styled-system';

const HeroBannerContainer = dynamic(() =>
  // @ts-ignore
  import('consumer_woc/components/HeroBanner').then(m => m.HeroBannerContainer, { ssr: false })
);

const SecondaryBanner = dynamic(
  () =>
    // @ts-ignore
    import('consumer_woc/components/HeroBanner').then(m => m.SecondaryBanner),
  {
    ssr: false,
  }
);

// @ts-ignore
const HeroBanner = dynamic(() => import('consumer_woc/components/HeroBanner'), { ssr: false });

const RemoteHeroBanner = ({
  data,
  onClickBannerCta,
  marginTop,
  paddingX,
  carouselIndex = 0,
}: {
  data: any;
  onClickBannerCta: (btn?: unknown) => void;
  marginTop?: SystemProps['marginTop'];
  paddingX?: SystemProps['paddingX'];
  carouselIndex?: number;
}) => {
  const { isStorePage, fullWidth, applyRadius, primaryBanner, secondaryBanner } = useMemo(() => {
    // This banner query response has already been transformed by the Rescript decoder so its
    // shape differs from the store banner.
    if (data.n1ColumnBanners.length) {
      return {
        fullWidth: data.width === 'full_width',
        applyRadius: data.isBorderRadius,
        primaryBanner: transformHeroBannerBlockData(data.n1ColumnBanners[carouselIndex], onClickBannerCta),
        secondaryBanner: null,
      };
    }

    if (data.n2ColumnBanner) {
      //@ts-ignore
      const [primaryBanner, secondaryBanner] = transformHeroBannerBlockData(data.n2ColumnBanner, onClickBannerCta);
      return {
        fullWidth: data.width === 'full_width',
        applyRadius: data.isBorderRadius,
        primaryBanner,
        secondaryBanner,
      };
    }

    // This is the unformatted Store banner query response so we must use a different transform
    // function to render the store page banner
    if (data.n1ColumnBanners.items.length) {
      return {
        isStorePage: true,
        fullWidth: getCmsItemCodename(data.width) === 'full_width',
        applyRadius: getCmsItemCodename(data.applyRadius) === 'yes',
        primaryBanner: transformStoreHeroBannerData(data.n1ColumnBanners.items?.[carouselIndex], onClickBannerCta),
        secondaryBanner: null,
      };
    }

    return {};
  }, [data, onClickBannerCta, carouselIndex]);

  if (!primaryBanner) return null;

  return (
    // @ts-ignore
    <HeroBannerContainer>
      <SimpleGrid
        columns={!!secondaryBanner ? { base: 1, xl: 3 } : 1}
        width={fullWidth ? 'full' : 'auto'}
        maxWidth={fullWidth ? 'full' : '1440px'}
        paddingX={paddingX}
        spacing="10px"
        marginX="auto"
        marginTop={marginTop}
      >
        {
          // @ts-ignore
          <HeroBanner
            gridColumn={{ base: '1 / -1', xl: 'span 2' }}
            rounded={applyRadius}
            fullWidth={fullWidth}
            isStorePage={isStorePage}
            {...primaryBanner}
          />
        }
        {!!secondaryBanner && (
          // @ts-ignore
          <SecondaryBanner
            gridColumn={{ base: '1 / -1', xl: 'span 1' }}
            rounded={applyRadius}
            fullWidth={fullWidth}
            {...secondaryBanner}
          />
        )}
      </SimpleGrid>
    </HeroBannerContainer>
  );
};

export default RemoteHeroBanner;
